@if (myself$ | async; as myself) {
  <div>
    @if (myProcesses$ | async; as myProcesses) {
      <div class="application-select-wrapper">
        <div
          class="application-select-context"
          [class.no-heading]="addingNewProcess?.id === 'purchase' && !selectedWorkPermitId"
          (click)="appSelect.open()">
          @if (addingNewProcess?.id !== 'purchase' || selectedWorkPermitId) {
            <span class="application-select-heading">
              {{ 'APPLICATION.CURRENTLY_SELECTED_APPLICATION' | translate }}
            </span>
          }
          <div class="standard-form-field">
            <mat-form-field appearance="outline" class="application-select-form-field">
              <mat-select
                #appSelect
                class="application-select-control"
                appMatSelectPanel
                [appMatPanelWidthValue]="600"
                [appMatOverlapTrigger]="true"
                [disableOptionCentering]="true"
                [hideSingleSelectionIndicator]="true"
                panelClass="main-applications-select"
                id="applicationSelect"
                (selectionChange)="applicationChanged.emit($event)"
                [compareWith]="compareSelectedApplication"
                [value]="selectedValue">
                <mat-select-trigger>
                  @if (selectedWorkPermitId) {
                    <div class="select-trigger-text-wrapper">
                      <span class="user-process-selected-option">
                        {{
                          (selectedWorkPermit?.permitType
                            ? 'MY_WORK_PERMITS.TYPE.' + selectedWorkPermit.permitType
                            : 'MY_WORK_PERMITS.TYPE_NOT_SPECIFIED'
                          ) | translate
                        }}
                      </span>
                      @if (selectedWorkPermit?.company?.name; as companyName) {
                        <span class="user-process-selected-option-sub is-truncated" [title]="companyName">
                          {{ 'MY_WORK_PERMITS.EMPLOYER' | translate }}: {{ companyName }}
                        </span>
                      }
                      @if (selectedWorkPermit?.status; as status) {
                        <div class="user-process-selected-status">
                          <span class="user-process-selected-status-dot"></span>
                          <span class="user-process-selected-status-text">
                            {{ 'MY_WORK_PERMITS.STATUS.' + status | translate }}
                          </span>
                        </div>
                      }
                    </div>
                  } @else {
                    @if (!addingNewProcess && myProcess; as userProcess) {
                      <div class="select-trigger-text-wrapper">
                        @if (!userProcess.processId) {
                          <!-- No application type assigned yet -->
                          <span class="user-process-selected-option">
                            {{ 'APPLICATION.NEW_APPLICATION' | translate }}
                          </span>
                          <span class="user-process-selected-option-sub">
                            {{ 'APPLICATION.APPLICATION_CREATED_AT' | translate }}
                            {{ userProcess.createdAt | date: 'dd-MM-yyyy' }}
                          </span>
                        } @else {
                          <!-- Application type assigned -->
                          @let categoryText = 'COMMON.PROCESS_CATEGORY.' + userProcess.process?.category | translate;
                          <span
                            class="user-process-selected-option"
                            [class.is-long]="categoryText.length > 22"
                            [class.is-longer]="categoryText.length > 38">
                            {{ categoryText }}
                          </span>
                          @if (userProcess.personalDetails?.name || userProcess.personalDetails?.surname) {
                            <span class="user-process-selected-option-sub">
                              {{ 'COMMON.LABEL.APPLICANT' | translate }}: {{ userProcess.personalDetails?.name }}
                              {{ userProcess.personalDetails?.surname }}
                            </span>
                          } @else {
                            <span class="user-process-selected-option-sub">
                              {{ 'APPLICATION.APPLICATION_CREATED_AT' | translate }}
                              {{ userProcess.createdAt | date: 'dd-MM-yyyy' }}
                            </span>
                          }
                        }

                        <!-- Current status (wraps for long labels) -->
                        <div class="user-process-selected-status">
                          <span class="user-process-selected-status-dot"></span>
                          <span class="user-process-selected-status-text">
                            <app-user-process-status [userProcess]="userProcess"></app-user-process-status>
                          </span>
                        </div>

                        <!-- Service level tag (styled for the blue background) -->
                        <div class="user-process-selected-service">
                          <app-service-level-tag
                            [userProcess]="userProcess"
                            [mode]="PurchaseTags.SMALL"></app-service-level-tag>
                        </div>
                      </div>
                    }
                    @if (addingNewProcess?.id === 'new') {
                      <div class="select-trigger-text-wrapper">
                        <span class="user-process-selected-option">
                          {{ 'APPLICATION.NEW_APPLICATION' | translate }}
                        </span>
                      </div>
                    }
                    @if (addingNewProcess?.id === 'purchase') {
                      <div class="select-trigger-text-wrapper">
                        <span class="user-process-selected-option is-long">
                          {{ 'COMMON.LAYOUT.IN_SERVICE_PURCHASING' | translate }}
                        </span>
                        <span class="user-process-selected-option-sub">
                          {{ 'COMMON.LAYOUT.CLICK_HERE_TO_PURCHASE_NEXT_APPLICATIONS' | translate }}
                        </span>
                      </div>
                    }
                  }
                </mat-select-trigger>
                @let showNewOption =
                  myself.allowedToAddOwnUserProcesses && myself.userProcessesLimit > myProcesses?.length;
                @let showPurchaseOption =
                  myself.company.purchaseEnabled &&
                  (!myself.allowedToAddOwnUserProcesses || myself.userProcessesLimit <= myProcesses?.length);
                @if (myWorkPermits?.length) {
                  @if (myProcesses.length || showNewOption || showPurchaseOption) {
                    <mat-optgroup [label]="'MY_WORK_PERMITS.SECTIONS.STAY_LEGALISATION' | translate">
                      <ng-container *ngTemplateOutlet="stayLegalisationOptions"></ng-container>
                    </mat-optgroup>
                  }
                  <mat-optgroup [label]="'MY_WORK_PERMITS.SECTIONS.WORK_PERMITS' | translate">
                    @for (workPermit of myWorkPermits; track workPermit.id) {
                      <mat-option [value]="{ id: workPermit.id, isWorkPermit: true }">
                        <div class="applications-select-option-content-wrapper">
                          <div class="select-item-column select-item-column-icon">
                            @if (workPermit.id === selectedWorkPermitId) {
                              <mat-icon> radio_button_checked </mat-icon>
                            } @else {
                              <mat-icon> radio_button_unchecked </mat-icon>
                            }
                          </div>
                          <div class="select-item-column select-item-column-data">
                            <div class="main-label">
                              {{
                                (workPermit.permitType
                                  ? 'MY_WORK_PERMITS.TYPE.' + workPermit.permitType
                                  : 'MY_WORK_PERMITS.TYPE_NOT_SPECIFIED'
                                ) | translate
                              }}
                            </div>
                            <div class="status-label">
                              {{ 'MY_WORK_PERMITS.STATUS.' + workPermit.status | translate }}
                            </div>
                            @if (workPermit.company?.name; as companyName) {
                              <div class="sub-label is-truncated" [title]="companyName">
                                {{ 'MY_WORK_PERMITS.EMPLOYER' | translate }}: {{ companyName }}
                              </div>
                            }
                          </div>
                        </div>
                      </mat-option>
                    }
                  </mat-optgroup>
                } @else {
                  <ng-container *ngTemplateOutlet="stayLegalisationOptions"></ng-container>
                }
                <ng-template #stayLegalisationOptions>
                  @for (userProcess of myProcesses; track userProcess) {
                    <mat-option [value]="userProcess">
                      <div class="applications-select-option-content-wrapper">
                        <div class="select-item-column select-item-column-icon">
                          @if (!addingNewProcess && !selectedWorkPermitId && userProcess.id === myProcess?.id) {
                            <mat-icon> radio_button_checked </mat-icon>
                          }
                          @if (addingNewProcess || selectedWorkPermitId || userProcess.id !== myProcess?.id) {
                            <mat-icon> radio_button_unchecked </mat-icon>
                          }
                        </div>
                        <div class="select-item-column select-item-column-data">
                          <div class="main-label">
                            @if (!(userProcess.personalDetails?.name && userProcess.personalDetails?.surname)) {
                              {{ 'APPLICATION.APPLICATION' | translate }}: {{ userProcess.name }}
                            } @else {
                              @if (userProcess.personalDetails?.name; as name) {
                                {{ name }}
                              }
                              @if (userProcess.personalDetails?.surname; as surname) {
                                {{ surname }}
                              }
                            }
                          </div>
                          <div
                            class="status-label"
                            [class.negative]="userProcess.status === UserProcessStatus.CHANGES_REQUESTED"
                            [class.positive]="
                              userProcess.status === UserProcessStatus.DOCUMENTS_SENT_TO_OFFICE_BY_POST ||
                              userProcess.status === UserProcessStatus.IMMIGROF_VISIT_COMPLETED
                            ">
                            <app-user-process-status [userProcess]="userProcess"></app-user-process-status>
                          </div>
                          @if (userProcess.process?.category) {
                            <div class="sub-label">
                              {{
                                'COMMON.PROCESS_CATEGORY.' + userProcess.process.category
                                  | translate
                                  | truncate: 100 : false
                              }}
                            </div>
                          }
                          <!-- only for purchased processes -->
                          <div class="sub-label services">
                            <app-service-level-tag
                              [userProcess]="userProcess"
                              [mode]="PurchaseTags.LARGE"></app-service-level-tag>
                          </div>
                        </div>
                      </div>
                    </mat-option>
                  }
                  @if (showNewOption) {
                    <mat-option [value]="{ id: 'new' }">
                      <div class="applications-select-option-content-wrapper">
                        <div class="select-item-column select-item-column-icon">
                          <mat-icon>add</mat-icon>
                          <!-- <mat-icon *ngIf="addingNewProcess?.id !== 'new'">radio_button_unchecked</mat-icon> -->
                        </div>
                        <div class="select-item-column select-item-column-data">
                          <div class="main-label">{{ 'APPLICATION.NEW_APPLICATION' | translate }}</div>
                          <div class="status-label">{{ 'APPLICATION.ADD_NEW_APPLICATION' | translate }}</div>
                        </div>
                      </div>
                    </mat-option>
                  }
                  @if (showPurchaseOption) {
                    <mat-option [value]="{ id: 'purchase' }">
                      <div class="applications-select-option-content-wrapper">
                        <div class="select-item-column select-item-column-icon">
                          <mat-icon>add</mat-icon>
                        </div>
                        <div class="select-item-column select-item-column-data">
                          <div class="main-label">{{ 'COMMON.LAYOUT.IN_SERVICE_PURCHASING' | translate }}</div>
                          <div class="status-label">
                            {{ 'COMMON.LAYOUT.CLICK_HERE_TO_PURCHASE_NEXT_APPLICATIONS' | translate }}
                          </div>
                        </div>
                      </div>
                    </mat-option>
                  }
                </ng-template>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    }
  </div>
}
